import { render, staticRenderFns } from "./OrgChooser.vue?vue&type=template&id=59f52971&scoped=true&"
import script from "./OrgChooser.vue?vue&type=script&lang=js&"
export * from "./OrgChooser.vue?vue&type=script&lang=js&"
import style0 from "./OrgChooser.vue?vue&type=style&index=0&id=59f52971&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f52971",
  null
  
)

component.options.__file = "OrgChooser.vue"
export default component.exports